// extracted by mini-css-extract-plugin
export default {"center":"Button_center__zdVMH","button":"Button_button__Zk130","buttonContent":"Button_buttonContent__xc9ms","shine":"Button_shine__Gsji5","shimmer":"Button_shimmer__ikPpt"};